import { IOfferSpendCrudModalLang } from '../../../types/lang'

export const offerSpendCrudModalLang: IOfferSpendCrudModalLang = {
	offer_spend_crud_modal: {
		title_create: 'Create offer spend_ua',
		title_edit: 'Edit offer spend_ua',
		title_remove_single: 'Remove <span>offer spend_ua</span>',
		title_notes_view: 'View notes for offer spend_ua',
		title_notes_edit: 'Edit notes for offer spend_ua',
		title_history_view: 'View history in offer spend_ua',
		title_by_account: 'View offer spend detail info by account {{account}} - {{date}}_ua',
		title_by_account_total: 'View TOTAL offer spend detail info - {{date}}_ua',
		title_by_offer: 'View offer spend detail info by offer {{offer}} - {{date}}_ua',
		title_by_offer_total: 'View TOTAL offer spend detail info - {{date}}_ua',
		title_by_offer_scope: 'View offer spend detail info by offer scope {{offerScope}} - {{date}}_ua',
		title_by_offer_scope_total: 'View TOTAL offer spend detail info - {{date}}_ua',
		field_offer_label: 'Offer_ua',
		field_offer_placeholder: 'Offer_ua',
		field_user_label: 'User_ua',
		field_user_placeholder: 'User_ua',
		field_date_label: 'Date_ua',
		field_date_placeholder: 'Date_ua',
		field_amount_label: 'Amount_ua',
		field_amount_placeholder: 'Type number_ua',
		field_notes_label: 'Notes_ua',
		field_notes_placeholder: 'Notes_ua',
		msg_remove_confirm: 'Are you sure?_ua',
		btn_create: 'Create_ua',
		btn_update: 'Save_ua',
		btn_remove: 'Remove_ua',
		btn_close: 'Close_ua'
	}
}